import { COMPANY_TYPE_LABELS, COMPANY_TYPES, CompanyEntity, ItemInfoType } from "interfaces";
import { getPhone, dateFormat, getShortName } from "utils";

export const getCompanyInfo = (data: CompanyEntity): Array<ItemInfoType> => {
  const { isResident, type, address } = data;

  const onlyTaxResidentRFTitle = type === COMPANY_TYPES.COMPANY ? "Учредители - резиденты РФ" : "Налоговый резидент РФ";
  return [
    {
      label: "Тип",
      text: `${COMPANY_TYPE_LABELS[type]}`,
      width: 6,
    },
    data.companyRegistrationNumber && {
      label: type === COMPANY_TYPES.COMPANY ? "ОГРН" : "ОГРНИП",
      text: data.companyRegistrationNumber,
      width: 6,
    },
    data.inn && {
      label: "ИНН",
      text: data.inn,
      width: 6,
    },
    data.kpp && {
      label: "КПП",
      text: data.kpp,
      width: 6,
    },

    address && {
      label: "Юридический адрес",
      text: address,
      width: 6,
    },
    data.postAddress && {
      label: "Почтовый адрес",
      text: data.postAddress,
      width: 6,
    },
    data.phone && {
      label: "Номер телефона",
      text: getPhone(data.phone),
      width: 6,
    },
    data.email && {
      label: "Email",
      text: data.email,
      width: 6,
    },
    data.contractNumber && {
      label: "Номер договора-основания",
      text: data.contractNumber,
      width: 6,
    },
    data.contractDate && {
      label: "Дата заключения",
      text: dateFormat(data.contractDate),
      width: 6,
    },
    // data.surname &&
    //   data.name && {
    //     label: "ФИО",
    //     text: getShortName(data.surname, data.name, data.patronymic ?? ""),
    //     width: 6,
    //   },
    data.surname && {
      label: "Фамилия",
      text: data.surname,
      width: 6,
    },
    data.name && {
      label: "Имя",
      text: data.name,
      width: 6,
    },
    data.patronymic && {
      label: "Отчество",
      text: data.patronymic,
      width: 6,
    },
    data.birthDate && {
      label: "Дата рождения",
      text: dateFormat(data.birthDate),
      width: 6,
    },
    data.identificationDocSeria && {
      label: "Серия паспорта",
      text: data.identificationDocSeria,
      width: 6,
    },
    data.identificationDocNumber && {
      label: "Номер паспорта",
      text: data.identificationDocNumber,
      width: 6,
    },
    data.identificationDocIssuer && {
      label: "Кем выдан",
      text: data.identificationDocIssuer,
      width: 6,
    },
    data.identificationDocIssueDate && {
      label: "Дата выдачи",
      text: dateFormat(data.identificationDocIssueDate),
      width: 6,
    },
    data.identificationDocIssuerCode && {
      label: "Код подразделения",
      text: data.identificationDocIssuerCode,
      width: 6,
    },

    {
      label: onlyTaxResidentRFTitle,
      text: data.isOnlyTaxResidentRF ? "Да" : "Нет",
      width: 6,
    },

    type === COMPANY_TYPES.COMPANY && {
      label: "Руководство - резиденты РФ",
      text: data.isControlPersonsRF ? "Да" : "Нет",
      width: 6,
    },

    type === COMPANY_TYPES.COMPANY && {
      label: "Юр. лицо - резидент РФ",
      text: isResident ? "Да" : "Нет",
      width: 6,
    },

    type === COMPANY_TYPES.COMPANY && {
      label: "Иностранная организация",
      text: data.isForeignOrg ? "Да" : "Нет",
      width: 6,
    },
  ].filter((c) => !!c);
};
